import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import PieChartComponent from './Component';

const MIN_PIE_CHART_HEIGHT = 400;

const PieChartContainer = props => {
  const [height, setHeight] = useState();
  const [width, setWidth] = useState();
  const containerRef = useRef(null);

  useEffect(() => {
    setWidth(Math.max(
      containerRef.current.clientWidth,
      MIN_PIE_CHART_HEIGHT
    ));

    setHeight(Math.max(
      containerRef.current.clientHeight,
      MIN_PIE_CHART_HEIGHT
    ));
  }, [containerRef]);

  return (
    <div ref={containerRef} className="flex justify-center">
      {
        containerRef.current &&
        <PieChartComponent
          {...props}
          canvasWidth={width}
          canvasHeight={height}
        />
      }
    </div>
  );
};

PieChartContainer.propTypes = {
  sectors: PropTypes.array.isRequired
};

export default PieChartContainer;
